export const ComputationTypes = {
  acr: { shortLabel: 'A.C.R.', label: 'Arrêt Cardio Respiratoire', code: 'acr', image: 'acr_picto2.png'},
  choc: { shortLabel: 'CHOC', label: 'Etat de Choc', code: 'choc', image: 'choc_picto2.png'},
  isr: { shortLabel: 'I.S.R.', label: 'Intubation Séquence Rapide', code: 'isr', image: 'isr_picto2.png'},
  sedation: { shortLabel: 'Sedation', label: '', code: 'sedation', image: 'sed_picto2.png'},
  // htic: { shortLabel: 'H.T.I.C.', label: 'Hyper Tension Intra Cranienne', code: 'htic', image: 'eme_picto2.png'},
};



// WEBPACK FOOTER //
// ./src/models/computation-types.data.ts